@use 'sass:map';
@use 'ui/styles/core-tokens' as core;

.envs {
  //&Header {
  //  align-items: flex-start;
  //  display: flex;
  //  gap: 10px;
  //  margin-bottom: 20px;
  //}
  //
  //&Checkbox {
  //  margin-top: 0px;
  //  padding-top: 0px;
  //  padding-left: 0px;
  //}

  &Add {
    display: flex;
    justify-content: flex-end;

    &Tooltip {
      margin-top: 0px;
      min-width: 55px;
    }
  }

  &Remove {
    &Tooltip {
      margin-top: 0px;
      min-width: 40px;
    }
  }

  &Item {
    display: grid;
    column-gap: 25px;
    grid-template-columns: repeat(1, minmax(0px, 1fr)) auto;

    &Header {
      align-items: center;
      display: flex;
      gap: 10px;
      margin-bottom: 20px;
    }

    &Source {
      align-items: center;
      column-gap: 10px;
      display: grid;

      &Value {
        grid-template-columns: repeat(1, minmax(0px, 1fr)) 0px;
      }
      &ValueFrom {
        grid-template-columns: repeat(1, minmax(0px, 1fr)) 0px;
      }
    }

    &Secret {
      margin-top: 0px;
    }

    &Tooltip {
      display: inline-block;

      &Text {
        top: 0px;
      }
    }
  }
}

.formArrayControlError {
  @include core.font(core.$s, core.$regular, map.get(core.$fonts, error));

  height: 4px;
  opacity: 1;

  &Hidden {
    opacity: 0;
  }
}
